"use client";

import { useQuery } from "@tanstack/react-query";
import { rmcClient } from "@/lib/rmcClient";
import { useAppStore } from "@/lib/store";
import { useEffect } from "react";

export function useActiveFY() {
  const setActiveFY = useAppStore((s) => s.setActiveFY);
  const q = useQuery({
    queryKey: ["financial-years", "active"],
    queryFn: async () => {
      const res = await rmcClient.getActiveFY();
      return res.data;
    },
    staleTime: 1000 * 60 * 10,
  });

  useEffect(() => {
    if (q.data) setActiveFY(q.data);
  }, [q.data, setActiveFY]);

  return q;
}
